// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","genericContainer":"_2ELtkcMpIJZ1yyH_kfj3I7","caption":"_1dJD2pSCq2-UhXWE_3mRfd","lightGrey":"#fcfcfc","title":"_3LJTx_OoLI16xR9mayxpar _2IbHD4FVxtBnbNHEUw2mS3","smallMaxWidth":"991px","container":"dLJxgyX1XEst13pZ_PESf _2ELtkcMpIJZ1yyH_kfj3I7","mainContent":"H1MnpMW823uArWFevvFZi","optionSection":"_5RkfbzetVLdv6MYIm4zAh","summarySection":"_1pmDTUfoLu9WuwuI3w04rd","modalContainer":"_2cVnxcIs4ui2NV6uMXBVia","buttonContainer":"_3HP_ZIH6RdG_iz34R-RG-3","button":"_25OnTqX5XifeDtE92YFZz6"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/installation-options/InstallationOptions.css
// module id = 832
// module chunks = 0